<template>
  <el-dialog
    title="登录"
    class="mini-dialog"
    :visible.sync="dialogVisible"
    v-dialogDrag
    :close-on-click-modal="false"
    :before-close="closeDialog"
  >
    <div>
      <el-form label-width="150px" label-position="right" :model="form" ref="form">
        <el-form-item
          label="账号"
          prop="accountValue"
          :rules="[{ required: true, message: '请输入账号', trigger: 'blur' }]"
        >
          <el-input v-model="form.accountValue" placeholder="请输入账号" clearable></el-input>
        </el-form-item>
        <el-form-item
          label="密码"
          prop="pwdValue"
          :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
          v-if="appConfig.loginType === 2"
        >
          <el-input
            v-model="form.pwdValue"
            placeholder="请输入密码"
            clearable
            type="password"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="flex justify-center items-center">
      <el-button type="primary" :loading="saveLoading" @click="save">保存</el-button>
      <el-button @click="closeDialog(null)">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SingleSignOnApi } from '@wiz-api/workbench-std'

const singleSignOnApi = new SingleSignOnApi()
export default {
  props: {
    appConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        accountValue: '',
        pwdValue: '',
      },
      saveLoading: false,
    }
  },
  computed: {
    userInfo() {
      return Wiz.AuthHooks.GetUserInfo()
    },
  },
  methods: {
    async save() {
      this.saveLoading = true
      const body = {
        ...this.form,
        userId: this.userInfo?.profile?.sub,
        appId: this.appConfig.id,
      }
      const [err] = await singleSignOnApi.addAppssoParams({
        body,
      })
      this.saveLoading = false
      if (!err) {
        this.$emit('save', body)
        this.closeDialog(null)
      }
    },
    closeDialog(done) {
      this.$refs.form.clearValidate()
      this.form = this.$options.data().form
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
  },
}
</script>

<style></style>
